// @flow

import type { TravelerType } from '@ta/hotels.trip-search-provider';
import type { State } from '../travelerInfo';
import type { Action } from '../state';

type ActionData = {|
  travelerType?: TravelerType,
  isTTIOpen?: boolean,
  stayDates?: string,
  guests?: string,
  defaultDates?: boolean,
  paramSeqId?: number,
|};

export type HotelsTravelerInfo = {|
  travelerType?: TravelerType,
  isTTIOpen?: boolean,
  stayDates?: string,
  guests?: string,
  defaultDates?: boolean,
  paramSeqId?: number,
|};

export const SET_HOTELS_DATES_GUESTS = 'SET_HOTELS_DATES_GUESTS';
export const SET_TRAVELER_TYPE = 'SET_TRAVELER_TYPE';
export const SET_TTI_OPEN_STATUS = 'SET_TTI_OPEN_STATUS';

export const setHotelsTravelerInfo = (
  stayDates: ?string,
  guests: ?string,
  defaultDates: ?boolean,
  paramSeqId: ?number,
) => ({
  type: SET_HOTELS_DATES_GUESTS,
  stayDates,
  guests,
  defaultDates,
  paramSeqId,
});

export const setTravelerTypeInfo = (travelerType: TravelerType) => ({
  type: SET_TRAVELER_TYPE,
  travelerType,
});

export const setTTIOpenStatus = (isTTIOpen: boolean) => ({
  type: SET_TTI_OPEN_STATUS,
  isTTIOpen,
});

const handleSetHotelsTravelerInfo = (state: State, action: ActionData) => {
  if (!state.hotels) {
    return {
      ...state,
      hotels: {
        stayDates: action.stayDates,
        guests: action.guests || '1_2', // If someone creates this by setting dates, we need valid guests
        defaultDates: !!(action.stayDates && action.defaultDates),
        paramSeqId: action.paramSeqId,
      },
    };
  }

  const hotels = { ...state.hotels };
  if (action.stayDates !== undefined) {
    hotels.stayDates = action.stayDates;
    hotels.defaultDates = false;
  }
  if (action.guests !== undefined) {
    hotels.guests = action.guests;
  }
  if (action.defaultDates !== undefined) {
    hotels.defaultDates = action.defaultDates;
  }
  if (action.paramSeqId !== undefined) {
    hotels.paramSeqId = action.paramSeqId;
  }

  return { ...state, hotels };
};

const handleSetTravelerTypeInfo = (state: State, action: ActionData) => {
  if (!state.hotels) {
    return {
      ...state,
      hotels: {
        travelerType: action.travelerType,
      },
    };
  }

  const hotels = { ...state.hotels };
  if (action.travelerType !== undefined) {
    hotels.travelerType = action.travelerType;
  }
  return { ...state, hotels };
};

const handleSetTTIOpenStatus = (state: State, action: ActionData) => {
  if (!state.hotels) {
    return {
      ...state,
      hotels: {
        isTTIOpen: action.isTTIOpen,
      },
    };
  }

  const hotels = { ...state.hotels };
  if (action.isTTIOpen !== undefined) {
    hotels.isTTIOpen = action.isTTIOpen;
  }

  return { ...state, hotels };
};

const emptyState = () => Object.freeze({});

export default (state: State = emptyState(), action: Action): State => {
  switch (action.type) {
    case SET_HOTELS_DATES_GUESTS:
      return handleSetHotelsTravelerInfo(state, action);
    case SET_TRAVELER_TYPE:
      return handleSetTravelerTypeInfo(state, action);
    case SET_TTI_OPEN_STATUS:
      return handleSetTTIOpenStatus(state, action);
    default:
      return state;
  }
};
